
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/icecream-parlor",
      function () {
        return require("private-next-pages/outlet/icecream-parlor.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/icecream-parlor"])
      });
    }
  